import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { AkciznaRoba } from './akcizna-roba';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-akcizna-roba',
  templateUrl: './akcizna-roba.component.html'
})
export class AkciznaRobaComponent
 extends BaseModalContainer<AkciznaRoba>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<AkciznaRoba>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
  }

  ngOnInit() {
  }

}
